module.exports = __webpack_public_path__ + "img/big2-2.69017674.jpg";